// Логотип сущности: image == null → заглушка с кодом (сервер не шлёт пустых строк).
import { useState } from 'react';
import styles from './TeamLogo.module.css';
import { leadingGraphemes } from './graphemes';

export function TeamLogo({ src, code, size = 24 }: { src: string | null | undefined; code?: string | null; size?: number }) {
  // Ошибка привязана к адресу: новый src (перестановка строк, смена команды) снова пробует картинку
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const failed = !!src && failedSrc === src;
  const style = { width: size, height: size };
  if (!src || failed) {
    return <span className={styles.placeholder} style={{ ...style, fontSize: size * 0.36 }} aria-hidden="true">
      {leadingGraphemes(code ?? '', 3)}
    </span>;
  }
  return <img className={styles.logo} style={style} src={src} alt="" loading="lazy" decoding="async"
    onError={() => setFailedSrc(src)} />;
}
